module.exports = __webpack_public_path__ + "img/home3-1.c68a1ac0.jpg";